import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const ScreenPlay: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m356.96 449.99c-4.23 0-8.49-.94-12.42-2.85-8.97-4.35-14.54-12.99-14.54-22.54v-159.19c0-9.83 5.8-18.58 15.15-22.83 10.08-4.59 21.88-2.95 30.08 4.17l96.12 83.58c5.67 4.94 8.83 11.95 8.65 19.25-.18 7.33-3.7 14.22-9.65 18.9l-96.12 75.62c-4.96 3.9-11.08 5.91-17.27 5.91zm3.04-176.73v143.85l86.85-68.33z' />
    <path d='m660 540h-540v-390h465c41.36 0 75 33.65 75 75zm-510-30h480v-285c0-24.81-20.19-45-45-45h-435z' />
    <path d='m510 630h-240v-30h210c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

ScreenPlay.displayName = 'ScreenPlay';

export default ScreenPlay;
